import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import Slider from "rc-slider";
import {salesChannelRegister} from "../../services/salesChannelRegister";

const Handle = Slider.Handle;

class DropdownSliderSize extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disabled: this.props.disabled,
            error: this.props.error,
            value: this.props.value,
            caption_sqft: this.props.caption_sqft,
            caption_sqm: this.props.caption_sqm
        };
    };

    componentWillMount() {};

    componentDidMount(){}

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            disabled: nextProps.disabled,
            error: nextProps.error,
            value: nextProps.value,
            caption_sqft: nextProps.caption_sqft,
            caption_sqm: nextProps.caption_sqm
        });
    }

    functions = {
        increase: () => {
            this.state.value++;
            this.props.onChange(this.state.value);
        },
        decrease: () => {
            let value = JSON.parse(JSON.stringify(this.state.value));
            value--;
            if(value === 0 || value > 0){
                this.state.value--;
                this.props.onChange(this.state.value);
            }
        },
        set: (value) => {
            this.props.onChange(value);
        }
    };

    renders = {
        handle: (props) => {
            const {value, ...restProps} = props;
            return (<Handle value={value} {...restProps} />);
        },
        sqm: (value) => {
            return this.renders.number(Math.round(value * 0.093)) + this.state.caption_sqm;
        },
        sqft: (value) => {
            return this.renders.number(Math.round(value)) + this.state.caption_sqft;
        },
        number: (number) => {
            try {
                number = Math.round(number * 100) / 100;
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        }
    };

    render() {
        return (
            <div className={Styles.slidersContainer}>
                <div className={Styles.sliderInner}>
                    <div className={Styles.sliderInnerContainer}>
                        <div onClick={() => this.functions.decrease()}
                             className={Styles.sliderInnerContainerCircle}>
                            <img className={Styles.sliderInnerContainerCircleMinus}
                                 src={require("../../assets/images/minus_icon_white_small.png")}/>
                        </div>
                        <div className={Styles.sliderInnerContainerInner}>
                            {
                                salesChannelRegister.get("name") === "propertybooster" &&
                                <Slider
                                    handleStyle={{backgroundColor: "#33b8cf"}}
                                    trackStyle={{backgroundColor: "#33b8cf"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    max={20000}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.value}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            }
                            {
                                salesChannelRegister.get("name") === "yieldlock" &&
                                <Slider
                                    handleStyle={{backgroundColor: "#00273A"}}
                                    trackStyle={{backgroundColor: "#00273A"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    max={20000}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.value}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            }
                            {
                                salesChannelRegister.get("name") === "boostabostad" &&
                                <Slider
                                    handleStyle={{backgroundColor: "#7ECF5B"}}
                                    trackStyle={{backgroundColor: "#7ECF5B"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    max={20000}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.value}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            }
                        </div>
                        <div onClick={() => this.functions.increase()}
                             className={cx(Styles.sliderInnerContainerCircle, Styles.sliderInnerContainerCircleRight)}>
                            <img className={Styles.sliderInnerContainerCirclePlus}
                                 src={require("../../assets/images/plus_sign_white_small.png")}/>
                        </div>
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={Styles.sliderInnerContainerInnerRail}/>
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#00273A'}:{}} className={Styles.sliderInnerContainerInnerRailLeft}/>
                    </div>
                    {
                        salesChannelRegister.get("name") !== "boostabostad" &&
                    <div className={Styles.sliderInnerBoxes}>
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={cx(Styles.sliderValue,Styles.sliderValueLong)}>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.sliderValueText}>
                                {this.renders.sqft(this.state.value)}
                            </div>
                        </div>
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={cx(Styles.sliderValueDivider)}>
                            /
                        </div>
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={cx(Styles.sliderValue,Styles.sliderValueLong)}>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.sliderValueText}>
                                {this.renders.sqm(this.state.value)}
                            </div>
                        </div>
                    </div>
                    }
                    {
                        salesChannelRegister.get("name") === "boostabostad" &&
                        <div className={Styles.sliderInnerBoxes}>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={cx(Styles.sliderValue,Styles.sliderValueLong)}>
                                <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.sliderValueText}>
                                    {this.renders.sqm(this.state.value)}
                                </div>
                            </div>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={cx(Styles.sliderValueDivider)}>
                                /
                            </div>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={cx(Styles.sliderValue,Styles.sliderValueLong)}>
                                <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.sliderValueText}>
                                    {this.renders.sqft(this.state.value)}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default DropdownSliderSize;


// WEBPACK FOOTER //
// ./src/components/dropdown-slider-size/component.js